import React, { useEffect, useState } from 'react'
import { getTodosFichajes, getTodosFichajesDescarga, getTrabajadores } from '../../services/apis';
import { SubHeader } from '../../utils/componentes-utiles/SubHeader';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import InfoIcon from '@mui/icons-material/Info';
import { Box, Button, Checkbox, CircularProgress, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SelectorMes } from '../../utils/componentes-utiles/SelectorMes';
import { exportarExcel, formatTime, mesName } from '../../utils/utils';
import { SelectorYear } from '../../utils/componentes-utiles/SelectorYear';
import DownloadIcon from '@mui/icons-material/Download';
import { AlertError } from '../../utils/componentes-utiles/AlertError';
import { DialogDescargaFichajes } from './DialogDescargaFichajes';
import { BarrasHorasSemanaEmpleado } from '../../utils/componentes-utiles/graficas/BarrasHorasSemanaEmpleado';
import AuditoriaFichajesDialog from './AuditoriaFichajes';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AutocompleteList from '../../utils/componentes-utiles/AutocompleteList';
import { DialogHorasInvertidas } from './DialogHorasInvertidas';
import { DialogFichajesUsuario, FichajesUsuario } from './DialogFichajesUsuario';
import { useInterval } from "react-use";

export const Fichajes = () => {

    const [fichajes, setFichajes] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [mes, setMes] = useState(new Date().getMonth() + 1);
    const [nombreMes, setNombreMes] = useState(mesName(mes));
    const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
    const [years, setYears] = useState([]);
    const [open, setOpen] = useState(false);
    const [dialogDescarga, setDialogDescarga] = useState(false);
    const [auditoria, setAuditoria] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [opcionesUsuarios, setOpcionesUsuarios] = useState([]);
    const [loadedFilters, setLoadedFilters] = useState(false);
    const [dialogHorasInvertidas, setDialogHorasInvertidas] = useState(false);
    const [filtros, setFiltros] = useState({ fechaDesde: '', fechaHasta: '' });
    const [datosFichajeSeleccionado, setDatosFichajeSeleccionado] = useState(null);
    const [esadmin, setEsadmin] = useState(false);

    useEffect(() => {
        const fechaDesde = `${yearSelected}-${String(mes).padStart(2, '0')}-01`;
        const lastDay = new Date(yearSelected, mes, 0).getDate();
        const fechaHasta = `${yearSelected}-${String(mes).padStart(2, '0')}-${lastDay}`;

        setFiltros({ fechaDesde, fechaHasta });
        setNombreMes(mesName(mes));
        setLoadedFilters(false);
    }, [mes, yearSelected]);

    useEffect(() => {
        if (filtros.fechaDesde && filtros.fechaHasta) {
            setLoadedFilters(false);

            consultarFichaje();
        }
    }, [filtros, selectedUsers]);

    useEffect(() => {
        cargarTrabajadores();
    }, []);


    const dias = ["Empleado", "Horas ", " ", "Jornadas"];

    const Navigate = useNavigate();

    // const obtenersoloFechaActual = () => {
    //     const now = new Date(); // Obtiene la fecha y hora actual
    //     const year = now.getFullYear(); // Obtiene el año
    //     const month = String(now.getMonth() + 1).padStart(2, '0'); // Obtiene el mes (añade 1 porque los meses van de 0 a 11)
    //     const day = String(now.getDate()).padStart(2, '0'); // Obtiene el día del mes

    //     // Devuelve la fecha en el formato "YYYY-MM-DD HH:MM:SS"
    //     return `${yearSelected}-${month}-${day}`;
    // };
    const consultarFichaje = async () => {
        try {
            const usuarioIds = selectedUsers.map(u => u.value); // Extrae solo los IDs
            const response = await getTodosFichajes(filtros.fechaDesde, filtros.fechaHasta, usuarioIds);
            console.log(response);
            
            setFichajes(response.data.fichajes);
            setYears(response.data.years);
            setEsadmin(response.esadmin);
            setLoaded(true);
            setLoadedFilters(true);
        } catch (error) {
            console.error("Error al consultar los fichajes:", error);
            Navigate('/error');
        }
    };

    // function formatTime(segundos) {
    //     const horas = Math.floor(segundos / 3600);
    //     const minutos = Math.floor((segundos % 3600) / 60);
    //     const seg = segundos % 60;
    //     return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(seg).padStart(2, '0')}`;
    // }

    const descargarFichajesDelMes = async () => {

        try {
            const response = await getTodosFichajesDescarga(mes, yearSelected);

            const fichajes = response.data.fichajes;

            const exportar = exportarExcel(fichajes, `fichajes_${mes}_${yearSelected}`);
            if (exportar) {
                console.log("exportado");


            } else {
                console.log("no exportado");
                setOpen(true);
            }
        } catch (error) {
            console.error("Error al añadir el cliente:", error);
        }

    }

    // useInterval(descargarFichajesDelMes, 60000);
    const cargarTrabajadores = async () => {
        try {
            const response = await getTrabajadores(); // Asegúrate de tener esta función en apis.js
            const opciones = response.data.map(item => ({
                label: item.nombre,
                value: item.id
            }));
            setOpcionesUsuarios(opciones);
        } catch (error) {
            console.error("Error al cargar trabajadores", error);
        }
    };
    useEffect(() => {
        // consultarFichaje();
        setNombreMes(mesName(mes));

    }, []);
    useEffect(() => {
        if (mes && yearSelected) {
            const fechaDesde = `${yearSelected}-${String(mes).padStart(2, '0')}-01`;
            const lastDay = new Date(yearSelected, mes, 0).getDate();
            const fechaHasta = `${yearSelected}-${String(mes).padStart(2, '0')}-${lastDay}`;
            setFiltros({ fechaDesde, fechaHasta });
            setNombreMes(mesName(mes));
        }
    }, [mes, yearSelected]);
    return (
        <Grid container direction={'row'} alignItems={'start'} justifyContent={'center'} xs={12}>
            <SubHeader />
            {!loaded && (<CircularProgress />)}
            {loaded && (
                <>
                    <Grid
                        container
                        direction={'row'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        xs={11.5} sm={11}

                    >
                        <Grid
                            container
                            direction={'row'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            xs={12} md={12}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                xs={12}
                                sx={{ mb: 2, backgroundColor: 'white', py: 2, px: 1, borderRadius: 1, boxShadow: 1, mt: 2 }}
                            >

                                {/* Título + Loading */}
                                <Grid item xs={12} sm={6} md={3.5} lg={2}>
                                    <Typography variant='h5'>
                                        Fichajes de {nombreMes}
                                    </Typography>
                                    <CircularProgress size={22} style={{ display: loadedFilters ? 'none' : 'block' }} />
                                </Grid>

                                {/* Botones Auditoría + Descarga */}
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    xs={12} sm={3} md={2} lg={1.5}
                                    gap={2}
                                >
                                    <Tooltip title="Auditoría de Fichajes" arrow>
                                        <Button onClick={() => setAuditoria(true)}>
                                            <VerifiedUserIcon color="primary" fontSize="large" />
                                        </Button>
                                    </Tooltip>

                                    <Tooltip title="Descargar Fichajes" arrow>
                                        <Button onClick={() => setDialogDescarga(true)}>
                                            <DownloadIcon color="primary" fontSize="large" />
                                        </Button>
                                    </Tooltip>

                                </Grid>

                                {/* Autocomplete Usuarios */}
                                <Grid item xs={12} sm={6} md={6} lg={2}>
                                    <AutocompleteList
                                        array={opcionesUsuarios}
                                        setArray={setSelectedUsers}
                                        label="Selecciona uno o más usuarios"
                                    />
                                </Grid>

                                {/* Fecha Desde */}
                                <Grid item xs={12} sm={2.5} md={2} lg={2}>
                                    <TextField
                                        label="Desde"
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={filtros.fechaDesde}
                                        onChange={e => setFiltros(prev => ({ ...prev, fechaDesde: e.target.value }))}
                                    />
                                </Grid>

                                {/* Fecha Hasta */}
                                <Grid item xs={12} sm={2.5} md={2} lg={2}>
                                    <TextField
                                        label="Hasta"
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={filtros.fechaHasta}
                                        onChange={e => setFiltros(prev => ({ ...prev, fechaHasta: e.target.value }))}
                                    />
                                </Grid>

                            </Grid>

                            {fichajes.length <= 0 && (
                                <Grid container xs={12} justifyContent={'center'} alignItems={'center'} sx={{ minHeight: '60vh' }}>
                                    <Typography variant='h6'>
                                        Todavía no hay fichajes
                                    </Typography>
                                </Grid>
                            )}
                            {fichajes && fichajes.length >= 1 && (
                                <TableContainer component={Paper} sx={{ minWidth: "100%" }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                {dias.map((opcion, key) => (
                                                    <TableCell key={key} align="start">
                                                        <Typography variant='h5'>
                                                        {opcion}
                                                        </Typography>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {fichajes.map((usuario) => (
                                                <TableRow key={usuario.id} align="start">

                                                    <TableCell><strong>{usuario.usuario}<Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        {usuario.activo && (
                                                            <>
                                                                <FiberManualRecordIcon sx={{ color: 'green', fontSize: 14 }} />
                                                                <Typography variant="body2" color="green">Activo</Typography>
                                                            </>
                                                        )}
                                                        {!usuario.activo && (
                                                            <>
                                                                <FiberManualRecordIcon sx={{ color: 'red', fontSize: 14 }} />
                                                                <Typography variant="body2" color="red">No Activo</Typography>
                                                            </>
                                                        )}

                                                    </Box></strong></TableCell>
                                                    <TableCell><strong>{formatTime(usuario.sumaFichaje)} </strong></TableCell>
                                                    {/* <TableCell>
                                                            <strong>
                                                                {(() => {
                                                                    const total = usuario.totalHorasTareas ?? 0;
                                                                    const horas = Math.floor(total);
                                                                    const minutos = Math.round((total - horas) * 60);
                                                                    return `${horas}h ${minutos}m`;
                                                                })()}
                                                            </strong>
                                                        </TableCell> */}
                                                    <TableCell align="center"><strong>{<Button><InfoIcon color='primary' fontSize="large" onClick={() => {
                                                        setDialogHorasInvertidas(true);
                                                        setDatosFichajeSeleccionado(usuario); // Agrega argumentos si es necesario, por ejemplo: setDatosFichajeSeleccionado(data)
                                                    }} /></Button>}</strong></TableCell>

                                                    <TableCell align="center" onClick={() => {
                                                        setDialogHorasInvertidas(true);
                                                        setDatosFichajeSeleccionado(usuario); // Agrega argumentos si es necesario, por ejemplo: setDatosFichajeSeleccionado(data)
                                                    }}
                                                    >
                                                        <BarrasHorasSemanaEmpleado data={usuario.horasSemana} jornada={usuario.jornada}></BarrasHorasSemanaEmpleado>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                        </Grid>
                        {
                            dialogDescarga && (
                                <DialogDescargaFichajes open={dialogDescarga} setOpen={setDialogDescarga} handleDownload={descargarFichajesDelMes} />
                            )
                        }
                        {auditoria && (
                            <AuditoriaFichajesDialog open={auditoria} onClose={() => setAuditoria(false)} mes={mes} yearSelected={yearSelected} />
                        )}
                        {dialogHorasInvertidas && (
                            <DialogFichajesUsuario
                                open={dialogHorasInvertidas}
                                onClose={() => setDialogHorasInvertidas(false)}
                                usuarioId={datosFichajeSeleccionado?.id}
                                esadmin={esadmin}
                            />
                        )}
                    </Grid>

                </>

            )}
        </Grid >
    );
}

